module.exports = __webpack_public_path__ + "f37f77634f7dc8c650f1067ef705f078.svg";